<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/system' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员管理</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card class="box-card">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input placeholder="请输入关键字" v-model="queryInfo.MemberAccount" clearable @clear="getUserList(1)">
            <el-button slot="append" icon="el-icon-search" @click="getUserList(1)"></el-button>
          </el-input>
        </el-col>
        <el-col :span="6">
          <el-button type="primary" @click="showEditCreate('add')">添加会员</el-button>
          <el-button type="primary" @click="export2Excel()">导出excel</el-button>
        </el-col>
      </el-row>

      <!-- 表格列表 -->
      <el-table :data="pagedata" style="width: 100%" border stripe size="mini">
        <el-table-column type="index" label="#"></el-table-column>
        <el-table-column prop="MemberAccount" label="会员账号">
        </el-table-column>
        <el-table-column prop="FullName" label="姓名"> </el-table-column>
        <el-table-column prop="Mailbox" label="邮箱"> </el-table-column>
        <el-table-column prop="CellPhoneNum" label="手机号"> </el-table-column>
        <el-table-column prop="Region" label="所属地区"> </el-table-column>
        <el-table-column prop="School" label="学校名称"> </el-table-column>
        <el-table-column prop="Major" label="专业"> </el-table-column>
        <el-table-column prop="Education" label="学历"> </el-table-column>
        <el-table-column prop="DeclarationMethod" label="申报方式" width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.DeclarationMethod.toString() === '1'" style="color: rgb(35 174 231)">
              以学校方式
            </div>
            <div v-else-if="scope.row.DeclarationMethod.toString() === '2'" style="color: rgb(240 169 36)">
              以个人方式
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="RegistrationTime" label="注册时间" :formatter="dataFormat" width="150">
        </el-table-column>
        <el-table-column label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditCreate('edit', scope.row)">修改</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteCreate(scope.row.MemberID)">删除</el-button>
            <el-button type="warning" icon="el-icon-setting" size="mini" @click="resetPwd(scope.row.MemberID)">重置密码</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pagenum"
                     :page-sizes="[10, 20, 50, 100]" :page-size="queryInfo.pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"
                     background>
      </el-pagination>

      <!-- 修改 -->
      <el-dialog :title="dialogTitle" :visible.sync="editDialogVisible" width="30%" @close="editresetFields">
        <el-form :model="editForm" :rules="editRules" ref="editFormRef" label-width="100px">
          <el-form-item label="会员账号" prop="MemberAccount">
            <el-input v-model="editForm.MemberAccount" :disabled="userstatus" placeholder="账号默认密码：8888"></el-input>
          </el-form-item>
          <!-- <el-form-item label="密码" prop="MemberPassword">
            <el-input v-model="editForm.MemberPassword"></el-input>
          </el-form-item> -->
          <el-form-item label="姓名" prop="FullName">
            <el-input v-model="editForm.FullName"></el-input>
          </el-form-item>
          <el-form-item label="邮箱" prop="Mailbox">
            <el-input v-model="editForm.Mailbox"></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="CellPhoneNum">
            <el-input v-model="editForm.CellPhoneNum"></el-input>
          </el-form-item>
          <el-form-item label="所属地区" prop="Region">
            <el-select v-model="editForm.Region" placeholder="请选择">
              <el-option v-for="item in regionOptions" :key="item.value" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校" prop="SchoolID">
            <el-select v-model="editForm.SchoolID" filterable placeholder="请选择" @change="handlerSelect">
              <el-option v-for="item in SchoolOptions" :key="item.SchoolID" :label="item.SchoolName" :value="item.SchoolID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="专业" prop="Major">
            <el-input v-model="editForm.Major"></el-input>
          </el-form-item>
          <el-form-item label="学历" prop="Education">
            <el-select v-model="editForm.Education" placeholder="请选择">
              <el-option v-for="item in educationOptions" :key="item.value" :label="item.label" :value="item.label">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="申报方式" prop="">
            <el-select v-model="editForm.DeclarationMethod" placeholder="请选择" style="width: 100%">
              <el-option v-for="item in declarationOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="editCreate()" :loading="isLoading">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    // 自定义验证规则
    var rulePhone = (rule, value, cb) => {
      // 手机号正则
      const regMobile =
        /^(0|86|17951)?(13[0-9]|15[0123456789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
      if (regMobile.test(value)) {
        return cb() // 验证合法有效
      }
      cb(new Error('请输入合法手机号'))
    }
    var Email = (rule, value, cb) => {
      // 邮箱
      const regEmail = new RegExp(
        '^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$'
      )
      if (!regEmail.test(value)) {
        cb(new Error('请输入正确的邮箱'))
      } else {
        cb()
      }
    }
    var isChinese = (rule, value, cb) => {
      // 不能使用中文正则
      const regChinese = /^[^\u4e00-\u9fa5]*$/
      if (!regChinese.test(value)) {
        cb(new Error('账号不能使用中文'))
      } else {
        cb()
      }
    }
    return {
      // 获取列表
      queryInfo: {
        // 查询参数
        MemberAccount: '',
        // 当前页码
        pagenum: 1,
        // 每页显示条数
        pagesize: 10
      },
      pagedata: [],
      total: 0,
      // 修改弹框显示状态
      editDialogVisible: false,
      // 弹窗默认标题
      dialogTitle: '',
      // 修改表单
      editForm: {
        MemberAccount: '',
        MemberPassword: '',
        FullName: '',
        Mailbox: '',
        CellPhoneNum: '',
        Region: '',
        School: '',
        SchoolID: '',
        Major: '',
        Education: '',
        RegistrationTime: '',
        DeclarationMethod: '1'
      },
      // 修改表单验证
      editRules: {
        MemberAccount: [
          {
            required: true,
            message: '请输入会员账号',
            trigger: 'blur'
          },
          {
            validator: isChinese,
            trigger: 'blur'
          }
        ],
        MemberPassword: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ],
        FullName: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }
        ],
        Mailbox: [
          {
            required: true,
            message: '请输入邮箱',
            trigger: 'blur'
          },
          {
            validator: Email,
            trigger: 'blur'
          }
        ],
        CellPhoneNum: [
          {
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          },
          {
            validator: rulePhone,
            trigger: 'blur'
          }
        ],
        Region: [
          {
            required: true,
            message: '请选择地区',
            trigger: 'change'
          }
        ],
        SchoolID: [
          {
            required: true,
            message: '请输入学校名称',
            trigger: 'blur'
          }
        ],
        Major: [
          {
            required: true,
            message: '请输入专业',
            trigger: 'blur'
          }
        ],
        Education: [
          {
            required: true,
            message: '请选择学历',
            trigger: 'change'
          }
        ],
        DeclarationMethod: [
          {
            required: true,
            message: '请选择申报方式',
            trigger: 'change'
          }
        ]
      },
      // 地区
      regionOptions: [
        {
          value: '1',
          label: '北京市'
        },
        {
          value: '2',
          label: '天津市'
        },
        {
          value: '3',
          label: '上海市'
        },
        {
          value: '4',
          label: '重庆市'
        },
        {
          value: '5',
          label: '河北省'
        },
        {
          value: '6',
          label: '山西省'
        },
        {
          value: '7',
          label: '辽宁省'
        },
        {
          value: '8',
          label: '吉林省'
        },
        {
          value: '9',
          label: '黑龙江省'
        },
        {
          value: '10',
          label: '江苏省'
        },
        {
          value: '11',
          label: '浙江省'
        },
        {
          value: '12',
          label: '福建省'
        },
        {
          value: '13',
          label: '江西省'
        },
        {
          value: '14',
          label: '山东省'
        },
        {
          value: '15',
          label: '四川省'
        },
        {
          value: '16',
          label: '河南省'
        },
        {
          value: '17',
          label: '湖北省'
        },
        {
          value: '18',
          label: '湖南省'
        },
        {
          value: '19',
          label: '广东省'
        },
        {
          value: '20',
          label: '海南省'
        },
        {
          value: '21',
          label: '贵州省'
        },
        {
          value: '22',
          label: '云南省'
        },
        {
          value: '23',
          label: '陕西省'
        },
        {
          value: '24',
          label: '甘肃省'
        },
        {
          value: '25',
          label: '青海省'
        },
        {
          value: '26',
          label: '台湾省'
        },
        {
          value: '27',
          label: '广西'
        },
        {
          value: '28',
          label: '内蒙'
        },
        {
          value: '29',
          label: '西藏'
        },
        {
          value: '30',
          label: '宁夏'
        },
        {
          value: '31',
          label: '新疆'
        }
      ],
      // 学历
      educationOptions: [
        {
          value: '1',
          label: '大专'
        },
        {
          value: '2',
          label: '本科'
        },
        {
          value: '3',
          label: '研究生'
        },
        {
          value: '4',
          label: '博士'
        }
      ],
      declarationOptions: [
        {
          value: '1',
          label: '以学校的方式提交作品（需学校推荐作品到大赛）'
        },
        {
          value: '2',
          label: '以个人的方式提交作品（无需学校推荐）'
        }
      ],
      // 会员账号编辑状态
      userstatus: false,
      // 按妞加载中
      isLoading: false,
      // 学校下拉
      SchoolOptions: [
        {
          value: '1',
          label: '北京大学'
        },
        {
          value: '2',
          label: '上海大学'
        }
      ]
    }
  },
  created() {
    // 默认获取列表
    this.getUserList(1)
    // 获取学校
    this.getSchool()
  },
  methods: {
    //   获取列表
    async getUserList(newPage) {
      this.queryInfo.pagenum = newPage
      const { data: res } = await this.$http.get('/api/Member/GetAllMembers', {
        params: this.queryInfo
      })
      if (res.StatusCode !== 1) return console.log(res.Msg)
      this.pagedata = res.Data.members
      this.total = res.Data.total
    },
    // 获取学校
    async getSchool() {
      const { data: res } = await this.$http.get('/api/School/GetAllSchoolName')
      this.SchoolOptions = res.Data.schools
      // this.SchoolOptions = res.Data.schools.map((item) => {
      //   return {
      //     value: item.SchoolID,
      //     label: item.SchoolName
      //   }
      // })
    },
    // 添加会员获取学校下拉当前选中的label值（学校名）
    handlerSelect(val) {
      if (val) {
        let obj = {}
        obj = this.SchoolOptions.find((item) => {
          return item.SchoolID === val
        })
        this.editForm.School = obj.SchoolName
      }
    },
    // 监听pagesize 切换显示多少条 事件
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize
      this.getUserList(1)
    },
    // 监听点击了第几页 事件
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage
      this.getUserList(newPage)
    },
    // 关闭弹窗重置表单验证
    editresetFields() {
      this.userstatus = false
      this.editForm = {
        MemberAccount: '',
        MemberPassword: '',
        FullName: '',
        Mailbox: '',
        CellPhoneNum: '',
        Region: '',
        School: '',
        SchoolID: '',
        Major: '',
        Education: '',
        RegistrationTime: '',
        DeclarationMethod: '1'
      }
      this.$refs.editFormRef.resetFields()
    },
    // 显示修改弹窗
    showEditCreate(type, row) {
      if (type === 'add') {
        this.dialogTitle = '添加会员'
      } else if (type === 'edit') {
        this.$nextTick(() => {
          // 注意看这里
          this.dialogTitle = '编辑会员'
          this.userstatus = true
          this.editForm = row
          this.editForm.DeclarationMethod = row.DeclarationMethod.toString()
          if (row.SchoolID === 0) {
            this.editForm.SchoolID = ''
          }
        })
      }
      this.editDialogVisible = true
    },
    // 添加/修改
    editCreate() {
      this.$refs.editFormRef.validate(async (valid) => {
        // 验证不通过跳出
        if (!valid) return false
        this.isLoading = true
        // 发起添加请求
        const { data: res } = await this.$http.post(
          '/api/Member/EditMember',
          this.editForm
        )
        console.log(res.StatusCode)
        // 判断状态码
        if (res.StatusCode !== 1) {
          this.isLoading = false
          return this.$message.error(res.Msg)
        }
        // 成功提示
        this.$message.success(res.Msg)
        this.isLoading = false
        // 关闭弹窗
        this.editDialogVisible = false
        // 刷新列表
        this.getUserList(this.queryInfo.pagenum)
      })
    },
    // 删除
    async deleteCreate(id) {
      // 提示是否确认删除
      const res = await this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch((err) => {
        return err
      })
      if (res !== 'confirm') return this.$message.info('已取消删除')
      const { data: resdel } = await this.$http.post(
        '/api/Member/DeleteMember?memberID=' + id
      )
      if (resdel.StatusCode !== 1) return this.$message.error('删除失败')
      this.$message.success('删除成功')
      // 刷新列表
      this.getUserList(this.queryInfo.pagenum)
    },
    // 重置密码
    async resetPwd(id) {
      // 提示用户输入新密码，默认值为8888
      const res = await this.$prompt(
        '请输入重置密码，默认不填写，密码为：8888',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          defaultValue: '8888' // 设置默认值为8888
        }
      ).catch((err) => {
        return err // 如果用户取消，返回 null
      })
      console.log(res)
      // 如果用户没有输入新密码（例如点击了取消按钮）
      if (res.action !== 'confirm') return this.$message.info('已取消重置密码')
      // 使用用户输入的新密码（如果用户输入了值）或默认值（如果用户没有输入值）
      const newPassword = res.value || '8888' // 如果value为空，则使用默认值8888
      // 发送请求
      const { data: resdel } = await this.$http.get(
        '/api/Member/ResetPassword',
        {
          params: { memberID: id, newPwd: newPassword }
        }
      )
      if (resdel.StatusCode !== 1) return this.$message.error('重置密码失败')
      this.$message.success('重置密码成功')
    },
    // 导出excel
    export2Excel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require('../../excel/Export2Excel')
        const tHeader = [
          '会员账号',
          '姓名',
          '邮箱',
          '手机号',
          '所属地区',
          '学校名称',
          '专业',
          '学历',
          '注册时间'
        ]
        const filterVal = [
          'MemberAccount',
          'FullName',
          'Mailbox',
          'CellPhoneNum',
          'Region',
          'School',
          'Major',
          'Education',
          'RegistrationTime'
        ]
        const list = this.pagedata
        const data = this.formatJson(filterVal, list)
        const tableFileName = '会员信息' + this.setTableFileName()
        exportJsonToExcel(tHeader, data, tableFileName)
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]))
    },
    setTableFileName() {
      return this.$moment(new Date()).format('YYYYMMDDHHmmss')
    },
    // 时间格式化
    dataFormat: function (row, column) {
      var date = row[column.property]
      if (date === undefined) {
        return ''
      }
      return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>
<style lang="less" scoped>
.el-date-editor.el-input {
  width: 100% !important;
}
</style>
